import { connect } from 'react-redux';

import { actionCreators, selectors as orgSelectors } from 'dux/org';

import BillingCard from './BillingCard';

const mapStateToProps = (state) => ({
  needsBilling: orgSelectors.needsBilling(state),
  isFastlaneCustomer: orgSelectors.isFastlaneCustomerSelector(state),
});

const mapDispatchToProps = {
  completeBillingSetup: actionCreators.completeBillingSetup,
  getOrg: actionCreators.getOrg,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingCard);
